import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { State } from "../../../dependencies/getState/State";
import { useEscapeLogic, useSetOpenLogic, useSetUserDataLogic } from "../../../logic";
import { DEFAULT_STATE } from "../constants";
export var useTopUpState = function useTopUpState(props) {
  var isOpen = props.isOpen;
  var _useState = useState(_objectSpread(_objectSpread({}, DEFAULT_STATE), {}, {
      isOpen: isOpen
    })),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];

  // NOTE: Желательно отвязаться от Рекатовского состояния в будущем полностью и зависеть от внешнего стейт менеджера
  // Так как на него легче подписаться без необходимости ререндеринга
  useEffect(function () {
    State.getInstance().initialize(state);
  }, [state]);

  // Сохраняет данные аккаунта для последующего использования
  useSetUserDataLogic(props, setState);
  // Позволяет открывать виджет на основе свойства "isOpen"
  useSetOpenLogic(state, setState, props);
  // Позволяет закрыть модальное окно при нажатии клавиши Escape
  useEscapeLogic(setState);
  return {
    getState: function getState() {
      return state;
    },
    setState: setState
  };
};